/**
 * File: createQuestionController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class CreateQuestionController {
    // @ngInject
    constructor($scope, $rootScope, $state, localStorageService, authService, archiveService, CQuesConst, ARCHIVE_CONSTANTS) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        $scope.is_qp_type_lW = false
        //On destroy function
        this.$onDestroy = () => {}
            /******* API CALL ********/
        let BASIC_DETAIL_URL = CQuesConst.API_GET_BASIC_DETAILS;
        let GET_QUES_URL = CQuesConst.API_GET_QUESTION;
        /************ SESSION DETAILS ***********/
        let schoolId = localStorageService.get("school_id")
        let authoringDetails = localStorageService.get("authoringData")
            //Wheter inside auth tool or not
        let isInsideAuthoring = false
            //inside auth tool set basic session details
        if (authoringDetails) {
            isInsideAuthoring = false;
            $scope.class_id = authoringDetails.class_id
            $scope.curriculum_id = authoringDetails.curriculum_id
            $scope.subject_id = authoringDetails.subject_id
        }
        //is practice or assessment
        $scope.isPractice = false;
        /****** STATIC FILTER *******/
        $scope.skillList = CQuesConst.SKILL_LIST;
        $scope.questionTypeList = CQuesConst.QUESTION_TYPE_LIST
        
            /****** VAR DECLARATION ****/
        $scope.question_type = undefined;
        $scope.linkSubjects = [];
        $scope.themesArray = [];
        $scope.waveDetails = [];
        $scope.strandsList = [];
        $scope.theme = {
            det: null
        };
        $scope.strand = [];
        $scope.wave = [];
        $scope.level = [];
        $scope.cognitive_skill = [];
        $scope.link_subject = [];
        $scope.link_theme = [];
        $scope.tag = [];
        $scope.isEditQuestion = false;
        //Strand auto complete
        $scope.querySearch = function querySearch(query) {
            let filteredStrands = _.filter($scope.strandsList, function(strand) {
                return strand.toLowerCase().indexOf(query.toLowerCase()) === 0
            })
            var results = query ? filteredStrands : [];
            return results;
        };

        /********* DYNAMIC FILTER ************/
        var getLinkSubjectDetails = () => {
            let apiRequestData = {
                curriculum_id: $scope.curriculum_id,
                class_id: $scope.class_id,
                subject_id: $scope.subject_id,
                school_id: schoolId
            }
            authService.callAPI(BASIC_DETAIL_URL, "POST", apiRequestData, function(resultObj) {
                let response = resultObj.result
                if (response.data) {
                    if (response.data.themeList && response.data.themeList.length > 0) {
                        let otherSubjects = _.filter(response.data.themeList, function(sub) {
                            return sub._id !== $scope.subject_id
                        })
                        $scope.linkSubjects = otherSubjects;
                        if ($scope.isTActivityQuestion || $scope.isTpActivityQuestion) {
                            let currentSubject = _.find(response.data.themeList, function(sub) {
                                return sub._id === $scope.subject_id
                            })
                            $scope.themesArray = currentSubject.themes;
                        }
                    }
                    if (response.data.strandList && response.data.strandList.length > 0) {
                        $scope.strandsList = response.data.strandList
                    }
                    if (response.data.waveList && response.data.waveList.length > 0) {
                        $scope.waveDetails = response.data.waveList
                    }
                }
                _.defer(() => {
                    $scope.$apply()
                })
            })
        }

        /********* SET ARCHIVE PAGE ***********/
        var setArchivePage = () => {
            $scope.isArchiveQuestion = true;
            $scope.isTActivityQuestion = false;
            if (!isInsideAuthoring) {
                $scope.class_id = $scope.$parent.$parent.class
                $scope.curriculum_id = $scope.$parent.$parent.curriculum
                $scope.subject_id = $scope.$parent.$parent.subject
                getLinkSubjectDetails();
                $scope.$watch('$parent.$parent.curriculum', function(newValue) {
                    if (newValue) {
                        $scope.curriculum_id = newValue
                        getLinkSubjectDetails();
                    }
                });

                $scope.$watch('$parent.$parent.class', function(newValue) {
                    if (newValue) {
                        $scope.class_id = newValue
                        getLinkSubjectDetails();
                    }
                });

                $scope.$watch('$parent.$parent.subject', function(newValue) {
                    if (newValue) {
                        $scope.subject_id = newValue
                        getLinkSubjectDetails();
                    }
                });
            } else {
                getLinkSubjectDetails();
            }
            $scope.question_type = $scope.$parent.$parent.questionType ? $scope.$parent.$parent.questionType : undefined
            $scope.theme.det = {
                theme_id: $scope.$parent.$parent.theme
            };
            $scope.$watch('$parent.$parent.questionType', function(newValue) {
                if (newValue) {
                    $scope.question_type = newValue
                }
            });

            $scope.$watch('$parent.$parent.theme', function(newValue) {
                if (newValue) {
                    $scope.theme.det = {
                        theme_id: newValue
                    };
                    $scope.isShowUploadCsv = true;
                }
            })
        }

        /********** SET TRADITIONAL ACTIVITY *********/
        var setTActivityPage = () => {
                $scope.isArchiveQuestion = false;
                $scope.isTActivityQuestion = true;
                $scope.isTpActivityQuestion = false;
                $scope.tqp_id = sessionDetails.qp_id;
                $scope.qp_title = sessionDetails.qp_title;
                $scope.isPractice = sessionDetails.isPractice;
                getLinkSubjectDetails();
            }
            /********** SET TP ACTIVITY *********/
        var setTpActivityPage = () => {
            $scope.isArchiveQuestion = false;
            $scope.isTpActivityQuestion = true;
            $scope.isTActivityQuestion = false;
            //$scope.tqp_id = sessionDetails.qp_id;
            //$scope.qp_title = sessionDetails.qp_title;
            $scope.isPractice = sessionDetails.isPractice;
            getLinkSubjectDetails();
        }

        /********** SET SESSION AND BASIC DETAILS ***********/
        var setSession = (sessionDetails) => {
            switch (sessionDetails.state) {
                case "archive":
                    setArchivePage()
                    break;
                case "tactivity":
                    setTActivityPage()
                    break;
                case "tpActivity":
                    setTpActivityPage()
                    break;
            }
            if (sessionDetails.question_id) {
                $scope.isLoading = true;
                $scope.isHideCreateSection = true;
                $scope.loadingMsg = "Loading question to edit... Please, wait..."
                authService.callAPI(GET_QUES_URL + sessionDetails.question_id, "GET", {}, function(resp) {
                    if (resp.result != undefined) {
                        let resultObj = resp.result;
                        let status = resultObj.status;
                        let result = resultObj.data.data;
                        if (status.code === 200) {
                            if (status.message == "Success") {
                                let linkSubjects = []
                                _.each(result.xlink, function(link) {
                                    if (linkSubjects.length > 0) {
                                        if (linkSubjects.findIndex(i => i._id === link.subject_id) === -1) {
                                            linkSubjects.push({
                                                _id: link.subject_id,
                                                name: link.subject_name
                                            })
                                        }
                                    } else
                                        linkSubjects.push({
                                            _id: link.subject_id,
                                            name: link.subject_name
                                        })
                                })
                                $scope.strandEntered = result.strand;
                                $scope.cognitive_skill = result.cognitive_skills;
                                $scope.strand = result.strand;
                                $scope.tag = result.tag;
                                $scope.level = result.level;
                                $scope.wave = result.wave;
                                $scope.link_subject = linkSubjects;
                                $scope.link_theme = result.xlink;
                                $scope.editQuestion = result;
                                $scope.question_type = result.type;
                                $scope.theme = {
                                    det: {
                                        theme_id: result.theme_id,
                                        theme_name: result.theme_name
                                    }
                                }
                                if ($scope.isArchiveQuestion) {
                                    $scope.$parent.$parent.theme = result.theme_id;
                                    $scope.$parent.$parent.questionType = result.type;
                                }
                                $scope.isLoading = false;
                                $scope.isHideCreateSection = false;
                                $scope.isEditQuestion = true;
                                _.defer(() => {
                                    $scope.$apply();
                                })
                            }
                        }
                    } else {
                        console.log("error : " + response.error)
                    }
                })
            }
        }

        //GET SESSION DETAILS
        let sessionDetails = localStorageService.get("createQuesiton")
        console.log(sessionDetails)
        if(sessionDetails && sessionDetails.is_qp_type_lW){
            $scope.is_qp_type_lW = true
            $scope.questionTypeList = ARCHIVE_CONSTANTS.ARCHIVE_QUESTION_TYPE_LIST_LW
        }
        setSession(sessionDetails)

        //TO GO TO ARCHIVE TO SELECT QUESTIONS
        $scope.goToArchive = () => {
            let qType = _.find($scope.questionTypeList, function(qn) {
                return qn._id === $scope.question_type
            })
            let searchFilters = []
            searchFilters.push({
                type: 'curriculum',
                value: {
                    _id: authoringDetails.curriculum_id,
                    name: authoringDetails.curriculum
                },
                deletable: false,
                visible: false
            });
            searchFilters.push({
                type: 'class',
                value: {
                    _id: authoringDetails.class_id,
                    name: authoringDetails.class
                },
                deletable: false,
                visible: false
            });
            searchFilters.push({
                type: 'subject',
                value: {
                    _id: authoringDetails.subject_id,
                    name: authoringDetails.subject
                },
                deletable: false,
                visible: false
            });
            searchFilters.push({
                type: "tab",
                value: {
                    _id: "question",
                    name: "Questions"
                },
                deletable: false,
                visible: false
            });
            searchFilters.push({
                type: "question_type",
                value: qType,
                deletable: true,
                visible: true
            })
            console.log(sessionDetails)
            let previousState
            if (sessionDetails.state === "tactivity") {
                previousState = {
                    state: 'createActivity',
                    params: {
                        qpId: $scope.qp_id ? $scope.qp_id : sessionDetails.qp_id,
                        activityId: sessionDetails.activity_id ? sessionDetails.activity_id : ""
                    }
                }
            } else {
                previousState = {
                    state: 'activityForm',
                    params: {
                        planId: sessionDetails.teaching_plan_id,
                        resourceId: sessionDetails.activity_id ? sessionDetails.activity_id : ""
                    }
                }
            }
            let details = {
                searchFilters: searchFilters,
                previousState: previousState,
                isMultiSelect: true,
                activeTab: "question",
                resourceType: {
                    _id: "question",
                    name: "Questions"
                },
            }
            archiveService.setRedirectJson(details)
            $state.go("archives")
        }

        //GOTO PREVIOUS PAGE ON CANCEL CLICK
        $scope.redirectToPreviousPage = () => {
            if (sessionDetails.isQuestionAvailable) {
                if (sessionDetails.state === "tactivity") {
                    $state.go('formatQuestion', {
                        qpId: sessionDetails.qp_id,
                        activityId: sessionDetails.activity_id ? sessionDetails.activity_id : ""
                    })
                } else {
                    $state.go('formatQp', {
                        resourceId: sessionDetails.activity_id ? sessionDetails.activity_id : ""
                    })
                }


            } else {
                if (sessionDetails.state === "tactivity") {
                    $state.go('createActivity', {
                        qpId: sessionDetails.qp_id,
                        activityId: sessionDetails.activity_id ? sessionDetails.activity_id : ""
                    })
                } else {
                    $state.go('activityForm', {
                        resourceId: sessionDetails.activity_id ? sessionDetails.activity_id : ""
                    })
                }
            }
        }

        //SET TAB TO SHOW ERROR MESSAGE
        var setSecondTab = () => {
            if ($scope.isTActivityQuestion) {
                $scope.selectedIndex = 1;
            }
        }

        //VALIDATE BASIC DETAILS
        var validate = (questionDetails) => {
            let activityErrorCount = 0
            $scope.errors = {}
            let isThemeError = false
            if (questionDetails.is_created_from_archive) {
                $scope.$parent.$parent.errors = {}
                if (!questionDetails.curriculum_id) {
                    $scope.$parent.$parent.errors["curriculum"] = "Please, Select a curriculum"
                    activityErrorCount++;
                }
                if (!questionDetails.class_id) {
                    $scope.$parent.$parent.errors["class"] = "Please, Select a class"
                    activityErrorCount++;
                }
                if (!questionDetails.subject_id) {
                    $scope.$parent.$parent.errors["subject"] = "Please, Select a subject"
                    activityErrorCount++;
                }
                if (questionDetails.theme) {
                    if (!questionDetails.theme._id) {
                        $scope.$parent.$parent.errors["theme"] = "Please, Select a theme"
                        activityErrorCount++;
                    }
                } else {
                    $scope.$parent.$parent.errors["theme"] = "Please, Select a theme"
                    activityErrorCount++;
                }
            } else {
                if (questionDetails.theme) {
                    if (!questionDetails.theme._id) {
                        isThemeError = true
                        $scope.errors["theme"] = "Please, Select a theme"
                        activityErrorCount++;
                    }
                } else {
                    isThemeError = true
                    $scope.errors["theme"] = "Please, Select a theme"
                    activityErrorCount++;
                }
            }
            if ($scope.question_type != "passage") {
                if (questionDetails.strand) {
                    if (questionDetails.strand.length <= 0) {
                        $scope.errors["strand"] = "Please, Enter atleast one strand"
                        if (!isThemeError) {
                            setSecondTab()
                        }
                        activityErrorCount++;
                    }
                } else {
                    $scope.errors["strand"] = "Please, Enter atleast one strand"
                    if (!isThemeError) {
                        setSecondTab()
                    }
                    activityErrorCount++;
                }
                if (questionDetails.level) {
                    if (questionDetails.level.length <= 0) {
                        $scope.errors["level"] = "Please, Enter atleast one level"
                        if (!isThemeError) {
                            setSecondTab()
                        }
                        activityErrorCount++;
                    }
                } else {
                    $scope.errors["level"] = "Please, Enter atleast one level"
                    if (!isThemeError) {
                        setSecondTab()
                    }
                    activityErrorCount++;
                }
                if (questionDetails.wave) {
                    if (questionDetails.wave.length <= 0) {
                        $scope.errors["wave"] = "Please, Enter atleast one wave"
                        if (!isThemeError) {
                            setSecondTab()
                        }
                        activityErrorCount++;
                    }
                } else {
                    $scope.errors["wave"] = "Please, Enter atleast one wave"
                    if (!isThemeError) {
                        setSecondTab()
                    }
                    activityErrorCount++;
                }
                if (questionDetails.cognitive_skill) {
                    if (questionDetails.cognitive_skill.length <= 0) {
                        $scope.errors["cognitive_skill"] = "Please, Enter atleast one skill"
                        if (!isThemeError) {
                            setSecondTab()
                        }
                        activityErrorCount++;
                    }
                } else {
                    $scope.errors["cognitive_skill"] = "Please, Enter atleast one skill"
                    if (!isThemeError) {
                        setSecondTab()
                    }
                    activityErrorCount++;
                }
            }
            return activityErrorCount;
        }

        //SAVE QUESION
        $scope.addQuestion = () => {
            $scope.isLoading = true;
            $scope.loadingMsg = "Question is saving... Please wait...";
            let activityErrorCount = 0
            let questionDetails = {
                curriculum_id: $scope.curriculum_id,
                class_id: $scope.class_id,
                subject_id: $scope.subject_id,
                qp_id: sessionDetails.qp_id,
                session_id: sessionDetails.session_id,
                batch_id: sessionDetails.batch_id,
                school_id: schoolId,
                question_type: $scope.question_type,
                strand: $scope.strand,
                theme: {
                    _id: ($scope.theme && $scope.theme.det && $scope.theme.det.theme_id) ? $scope.theme.det.theme_id : "",
                    name: ($scope.theme && $scope.theme.det && $scope.theme.det.theme_name) ? $scope.theme.det.theme_name : "",
                },
                tag: $scope.tag,
                level: $scope.level,
                wave: $scope.wave,
                link_subject: $scope.link_subject,
                link_theme: $scope.link_theme,
                cognitive_skill: $scope.cognitive_skill,
                qp_id: $scope.tqp_id,
                activity_id: sessionDetails.activity_id,
                is_traditional_activity: $scope.isTActivityQuestion,
                is_created_from_archive: $scope.isArchiveQuestion,
                isPractice: $scope.isPractice,
                isNotAddToQp: $scope.isArchiveQuestion ? $scope.isArchiveQuestion : false,
                teaching_plan_id: sessionDetails.teaching_plan_id
            }
            activityErrorCount = validate(questionDetails)
            localStorageService.set("questionDetails", {
                question: questionDetails,
                errorCount: activityErrorCount
            })
            switch ($scope.question_type) {
                case 'MCQ':
                    $scope.$broadcast('addMcqQuestion')
                    break;
                case 'TF':
                    $scope.$broadcast('addTfQuestion')
                    break;
                case 'FIB':
                    $scope.$broadcast('addFibQuestion')
                    break;
                case 'MTF':
                    $scope.$broadcast('addMatchQuestion')
                    break;
                case 'OWQ':
                    $scope.$broadcast('addOwqQuestion')
                    break;
                case 'SA':
                    $scope.$broadcast('addShortQuestion')
                    break;
                case 'LA':
                    $scope.$broadcast('addLongQuestion')
                    break;
                case 'passage':
                    $scope.$broadcast('addPassage')
                    break;
                case 'DRAW':
                    $scope.$broadcast('addDrawing')
                    break;
                case 'ASLSPEAK':
                    $scope.$broadcast('addAslSpeaking')
                    break;
                case 'ASLLISTEN':
                    $scope.$broadcast('addAslListening')
                    break;
            }
        }

        //RESET VALUES
        $rootScope.resetValues = () => {
            $scope.strand = [];
            $scope.wave = [];
            $scope.level = [];
            $scope.cognitive_skill = [];
            $scope.link_subject = [];
            $scope.link_theme = [];
            $scope.tag = [];
            if ($scope.question_type == 'passage') {
                $scope.question_type = ""
                $scope.theme.det = ""
            }
        }

        //HIDE SAVE BUTTON ON SERVER CALL
        $rootScope.setHideSaveButton = (value) => {
            $scope.isSaveClicked = value;
        }

        //SET LOADER WHILE EDIT OR SAVE
        $rootScope.setLoader = (value, msg) => {
            $scope.isLoading = value;
            if (value) {
                $scope.loadingMsg = msg;
            }
        }
    };
}

export default CreateQuestionController;



// WEBPACK FOOTER //
// ./src/app/createQuestion/controllers/createQuestionController.js